import { Button, Flex, H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { Citta } from "../../types"
import { useNavigate, useParams } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import CittaForm from "./CittaForm"
import { useCitta, useCittaDelete, useCittaUpdate } from "../../hooks/citta"
import { initialValuesCitta, validationSchemaCitta } from "./CittaCommon"
import { useMemo } from "react"
import useModalTrigger from "magik-react-hooks/useModalTrigger"
import ModalDelete from "../../components/ModalDelete"
import { ScrollLayout } from "../../components/ScrollLayout"
import { transformErrorForForm } from "../../utils/utils"

export default function CittaUpdate() {
  const { id } = useParams()
  const { data: citta } = useCitta(Number(id))
  const updateCitta = useCittaUpdate()
  const navigate = useNavigate()

  const [modalCittaDeleteState, modalCittaDeleteActions] = useModalTrigger()

  const deleteCitta = useCittaDelete()

  useBreadcrumbs([{ label: "Città", href: "/citta/citta" }, { label: "Dettaglio Città" }])

  const initialValues = useMemo(() => initialValuesCitta(citta), [citta])
  const validationSchema = useMemo(() => validationSchemaCitta(), [])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <Flex justifyContent="between" alignItems="center">
          <H1>{citta?.nome}</H1>
          <Button
            size="md"
            leadingIcon="delete"
            variant="danger"
            title="Elimina"
            onClick={() => {
              modalCittaDeleteActions.open()
            }}
          />
        </Flex>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
              return updateCitta.mutateAsync(values as Citta).then((citta) => {
                navigate(`/citta/citta`)
              }).catch((e) => {
                actions.setErrors(transformErrorForForm(e))
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <CittaForm />
                </Container>
                <BottomFormFixed url="/citta/citta" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
      <ModalDelete
        isOpen={modalCittaDeleteState.isOpen}
        onClose={modalCittaDeleteActions.close}
        onDelete={() => {
          return deleteCitta.mutateAsync(citta?.id).then(() => {
            navigate(`/citta/citta`)
          })
        }}
        message="Sei sicuro di voler eliminare questa città?"
        title="Elimina città"
      />
    </Layout>
  )
}
